import useEditCharacterRune from '../composables/useEditCharacterRune'
//------------------------------
// edit character runes harness
//------------------------------
export default async function useEditCharacterRunesHarness(changed_runes) {
  console.log('---------------------------------------')
  console.log('IN useEditCharacterRunesHarness')
  //-------------------------------------------
  // manages all character rune updates (CRUD)
  //-------------------------------------------
  //--------------------------------------
  // create promise for each rune update
  //--------------------------------------
  const promises = changed_runes.map((r) => {
    console.log('IN useEditCharacterRunesHarness - PROCESSING RUNE:', r)
    //-------------------
    // call api function
    //-------------------
    return useEditCharacterRune(r)
  })
  //------------------------------------------------------------
  // wait for all updates to complete - let errors propagate up
  //------------------------------------------------------------
  const results = await Promise.all(promises)
  //-----------------------------
  // optionally return responses
  //-----------------------------
  // if (returnResponses) return results
  return results
  //----------------------------------------------
  // else no response (caller awaited completion)
  //----------------------------------------------
  // return
}
